import React, { useState } from 'react'
import "mapbox-gl/dist/mapbox-gl.css";
import Map, {
  Marker,
  NavigationControl,
  GeolocateControl,
} from "react-map-gl";

import styles from "./MapBox.module.scss";

// added the following 6 lines.
import mapboxgl from 'mapbox-gl';

// The following is required to stop "npm build" from transpiling mapbox code.
// notice the exclamation point in the import.
// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax, import/no-unresolved
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;

interface MapProps {
  riskMarkers?: RiskMarkers[] | null;
  mapHeight?: string;
  zoom?: number;
  showControl?: boolean;
  height?: string ;
  width?: string ;
}
interface RiskMarkers {
  longitude: number;
  latitude: number;
  risk?: number;
}

export default function MapBox({
  riskMarkers,
  mapHeight = "17rem",
  height = "100%", 
  width = "100%",
  zoom = 1.5,
  showControl,
}: MapProps) {
  const TOKEN =
    "pk.eyJ1IjoicGlvdHJtYXR1c3pjemFrdWkiLCJhIjoiY2xnNTZrZGtyMDAzbzNzbWwxMW1oM2h0cCJ9.ZYCQGX55GiPblc05rwqFBA";


  const mapSize = {
    "--height": height,
    "--width": width,
    height: `calc(100vh - ${mapHeight})`,
  } as React.CSSProperties;


  return (
    <div className={styles.mapContainer} style={mapSize}>
      <Map
        mapboxAccessToken={TOKEN}
        style={{ height, width }}
        mapStyle="mapbox://styles/piotrmatuszczakui/clgbxevjn006401qxypdeqlk0"
        projection="globe"
        initialViewState={{
          zoom,
        }}
      >
        {showControl && (
          <>
            <NavigationControl position="top-right" />
            <GeolocateControl position="top-right" />
          </>
        )}

        {riskMarkers?.map((marker, i) => (
          <Marker
            key={i}
            latitude={marker.latitude}
            longitude={marker.longitude}
            anchor="bottom"
          >
            <span
              className={`${styles.marker} ${
                marker.risk === 1 && styles.high
              } ${marker.risk === 2 && styles.medium}`}
            ></span>
          </Marker>
        ))}
      </Map>
    </div>
  );
}
